export const presets = {
  efficient: {
    formality: 'Strictly Professional',
    verbosity: 'Concise',
    empathy: 'Polite and Neutral',
    proactivity: 'Offers Clarifications',
    humor: 'Completely Serious'
  },
  friendly: {
    formality: 'Friendly and Approachable',
    verbosity: 'Balanced',
    empathy: 'Warm and Understanding',
    proactivity: 'Suggestive',
    humor: 'Friendly and Playful'
  },
  helpful: {
    formality: 'Business Casual',
    verbosity: 'Detailed',
    empathy: 'Warm and Understanding',
    proactivity: 'Fully Proactive',
    humor: 'Occasional Dry Wit'
  }
};

export const traitOptions = {
  formality: [
    'Strictly Professional',
    'Business Casual', 
    'Friendly and Approachable',
    'Very Casual'
  ],
  verbosity: [
    'Brief and Direct',
    'Concise',
    'Balanced',
    'Detailed',
    'Thorough'
  ],
  empathy: [
    'Purely Factual',
    'Polite and Neutral',
    'Warm and Understanding',
    'Highly Empathetic'
  ],
  proactivity: [
    'Strictly Reactive',
    'Offers Clarifications',
    'Suggestive',
    'Fully Proactive'
  ],
  humor: [
    'Completely Serious',
    'Occasional Dry Wit',
    'Friendly and Playful',
    'Genuinely Comedic'
  ]
};

export const traitDescriptions = {
  formality: "How formal should your assistant sound? Choose between a strictly professional tone or a more casual, friendly vibe.",
  verbosity: "How much detail should your assistant provide? Choose between short, direct answers or more thorough explanations.",
  empathy: "How much emotion and understanding should your assistant show? This is especially important when dealing with frustrated or happy customers.",
  proactivity: "Should your assistant wait for specific instructions or actively suggest next steps and solutions?",
  humor: "Is it okay for your assistant to be a little playful? Adjust how much, if any, humor you'd like it to use."
};

export const exampleResponses = {
  formality: {
    'Strictly Professional': "Certainly, Sir/Ma'am. I shall assist you with your inquiry immediately.",
    'Business Casual': "Of course! I'll be happy to help you with that.",
    'Friendly and Approachable': "Absolutely! No problem at all - I've got you covered.",
    'Very Casual': "Sure thing! I can totally get that sorted out for you!"
  },
  verbosity: {
    'Brief and Direct': "Appointment booked.",
    'Concise': "Your appointment is booked for 2 PM tomorrow.",
    'Balanced': "I've successfully booked your appointment for 2 PM tomorrow. You'll receive a confirmation email shortly.",
    'Detailed': "I've booked your appointment for 2 PM tomorrow with Dr. Smith. You'll receive a confirmation email with all the details, including the address and what to bring.",
    'Thorough': "Perfect! I've scheduled your appointment for 2 PM tomorrow with Dr. Smith at the downtown office. You'll get a confirmation email with the address, parking info, and a reminder of what to bring. Would you like me to add this to your calendar as well?"
  },
  empathy: {
    'Purely Factual': "Your appointment has been cancelled. Next available slot is Friday.",
    'Polite and Neutral': "I understand you need to cancel. I can reschedule you for Friday.",
    'Warm and Understanding': "I understand that must be frustrating. Let me help you find a new time that works better.",
    'Highly Empathetic': "Oh no, I'm so sorry this isn't working out for you! I completely understand how disappointing that must be. Let me do everything I can to find you a perfect alternative time."
  }
};